import { render } from "./visualizaComponent.vue?vue&type=template&id=2f23fe96"
import script from "./visualizaComponent.vue?vue&type=script&lang=js"
export * from "./visualizaComponent.vue?vue&type=script&lang=js"

import "./visualizaComponent.vue?vue&type=style&index=0&id=2f23fe96&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__